import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { StateResponse } from "../../shared/models/state.model";
import { StateService } from "../../shared/services/state.service";

@Injectable({
    providedIn: 'root',
})
export class GetStateResolver implements Resolve<StateResponse[]> {

    constructor(private stateService: StateService) { }

    resolve(): Observable<StateResponse[]> {
        return this.stateService.getAll();
    }
}
